import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
import Login from '@/components/Login'

const index = () => import('@/views/index')
const about = () => import('@/views/about')
const robot = () => import('@/views/robot')
const buyGuide = () => import('@/views/buyGuide')
const afterSale = () => import('@/views/afterSale')
const operMarket = () => import('@/views/operMarket')
const operProduct = () => import('@/views/operProduct')
const taipuFuture = () => import('@/views/taipuFuture')
const club = () => import('@/views/club')
const cityPartners = () => import('@/views/cityPartners')
const login = () => import('@/views/login')
const userInfo = () => import('@/views/userInfo')
const newsDetail = () => import('@/views/newsDetail')
const qrcode = () => import('@/views/qrcode')
const useGuide = () => import('@/views/h5/useGuide')
const productIntro = () => import('@/views/h5/productIntro')
const emergency = () => import('@/views/h5/emergency')
const aboutUs = () => import('@/views/h5/aboutUs')
const agreementPay = () => import('@/views/h5/agreementPay')
const agreementService = () => import('@/views/h5/agreementService')
const miniSchemePage = () => import('@/views/h5/miniSchemePage')  // 生成小程序 url scheme 的中间页面
const lianlianBankPay = () => import('@/views/h5/lianlianBankPay')  // 连连银行卡支付中间页面
const lianlianBankPayiframe = () => import('@/views/h5/lianlianBankPayiframe')  // 连连银行卡iframe支付中间页面
const identityCard = () => import('@/views/h5/identityCard')  // 身份证输入
const toYyxMini = () => import('@/views/h5/toYyxMini')  // 跳转悦悦喜


Vue.use(Router)

export default new Router({

    mode: 'history',
    routes: [
        {
            path: '/',
            name: '产品介绍',
            component: Layout,
            leaf: true,
            children: [
                { path: '/', alias:'/robot', component: index, name: '产品介绍'},
                { path: '/robot/b', component: robot, name: 'B系列-大巴车',  },
                { path: '/robot/c', component: robot, name: 'C系列-乘用车', props: route => ({ index: route.query.index }), navs: [
                    'C-C505', 'C-C206', 'C-X612', 'C-X701', 'C-Q系列', 'C-Z201（自助）', 'C-W001/F', 'C-M801'
                ]},
                { path: '/robot/d', component: robot, name: 'D系列-高铁动车'  },
                { path: '/robot/g', component: robot, name: 'G系列-工程车'  },
                // { path: '/robot/c', component: robot, name: 'C系列' },
                // { path: '/robot/x', component: robot, name: 'X系列' },
                // { path: '/robot/q', component: robot, name: 'Q系列' },
                // { path: '/robot/m', component: robot, name: 'M系列' },
                // { path: '/robot/zl9', component: robot, name: 'ZL9系列' },
            ]
        },
        {
            path: '/buyGuide',
            name: '选购指南',
            component: Layout,
            leaf: true,
            children: [
                { path: '/buyGuide', component: buyGuide, name: '选购指南'},
            ]
        },

        {
            path: '/operMarket',
            name: '运营支持',
            component: Layout,
            leaf: true,
            children: [
                { path: '/operMarket', component: operMarket, name: '运营支持'},
            ]
        },
        {
            path: '/afterSale',
            name: '售后支持',
            component: Layout,
            leaf: true,
            children: [
                { path: '/afterSale', component: afterSale, name: '售后支持' },
            ]
        },

        {
            path: '/about',
            name: '走进太仆',
            component: Layout,
            leaf: true,
            children: [
                { path: '/about', component: about, name: '走进太仆' }
            ]
        },

        // {
        //     path: '/taipuFuture',
        //     name: '太仆未来',
        //     component: Layout,
        //     leaf: true,
        //     children: [
        //         { path: '/taipuFuture', component: taipuFuture, name: '太仆未来' }
        //     ]
        // },

        // {
        //     path: '/club',
        //     name: 'CLUB',
        //     component: Layout,
        //     leaf: true,
        //     children: [
        //         { path: '/club', component: club, name: 'CLUB' }
        //     ]
        // },

        {
            path: '/cityPartners',
            name: '城市合伙人',
            component: Layout,
            leaf: true,
            children: [
                { path: '/cityPartners', component: cityPartners, name: '城市合伙人' }
            ]
        },
        // {
        //     path: '/cityPartners',
        //     name: '城市拍档',
        //     component: Layout,
        //     leaf: true,
        //     children: [
        //         { path: '/cityPartners', component: cityPartners, name: '城市拍档' }
        //     ]
        // },
        {
            path: '/newsDetail',
            name: '',
            hidden: true,
            component: Layout,
            leaf: true,
            children: [
                { path: '/newsDetail/:id', component: newsDetail, hidden: true, name: '新闻内容' }
            ]
        },
        {
            path: '/userInfo',
            component: Layout,
            beforeEnter: (to, from, next) => {
                if (sessionStorage.getItem('userId')) {
                    next()
                } else {
                    next({ path: '/login' })
                }
            },
            leaf: true,
            hidden: true,
            children: [
                { path: '/userInfo/', component: userInfo, name: '我的' },
            ]
        },
        {
            path: '/qrcode',
            component: qrcode,
            leaf: true,
            hidden: true,
            children: [
                { path: '/qrcode/:type/:id/:partner', component: qrcode, name: '二维码', hidden: true },
                { path: '/qrcode/:type/:id', component: qrcode, name: '二维码', hidden: true }
            ]
        },
        {
            path: '/h5/useGuide',
            component: useGuide,
            hidden: true,
        },
        {
            path: '/h5/productIntro',
            component: productIntro,
            hidden: true,
        },
        {
            path: '/h5/emergency',
            component: emergency,
            hidden: true,
        },
        {
            path: '/h5/aboutUs',
            component: aboutUs,
            hidden: true,
        },
        {
            path: '/h5/agreementPay',
            component: agreementPay,
            hidden: true,
        },
        {
            path: '/h5/agreementService',
            component: agreementService,
            hidden: true,
        },
        {
            path: '/h5/s/:id',
            component: miniSchemePage,
            hidden: true,
        },
        {
            path: '/h5/lianlianBankPay/:link',
            component: lianlianBankPay,
            hidden: true,
        },
        {
            path: '/h5/lianlianBankPayiframe/:link',
            component: lianlianBankPayiframe,
            hidden: true,
        },
        {
            path: '/h5/identityCard/:id',
            component: identityCard,
            hidden: true,
        },
        {
            path: '/h5/toyyx/',
            component: toYyxMini,
            hidden: true,
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if(to.hash == '#contact-us') {
            setTimeout(function() {
                window.scroll({
                    top: 3800,
                    behavior: 'smooth'
                });
            }, 300)
        }
      }
})


// WEBPACK FOOTER //
// ./src/router/index.js